'use client';

import { m, useReducedMotion } from 'motion/react';
import { usePathname } from 'next/navigation';
import { Breadcrumbs, type TBreadcrumbStep } from './breadcrumbs';
import { fadeSlideUp } from '@/utils/animation/variants';

type AnimatedBreadcrumbsProps = {
  lastItemTitle?: string;
  /** An explicit trail — see `Breadcrumbs`. */
  items?: TBreadcrumbStep[];
};

export const AnimatedBreadcrumbs = ({ lastItemTitle, items }: AnimatedBreadcrumbsProps) => {
  const prefersReducedMotion = useReducedMotion();
  const pathname = usePathname();

  return (
    <m.div
      key={pathname}
      initial={prefersReducedMotion ? false : 'hidden'}
      animate="visible"
      variants={fadeSlideUp}
      className="mb-8 overflow-hidden"
    >
      <div className="min-w-0">
        <Breadcrumbs lastItemTitle={lastItemTitle} items={items} />
      </div>
    </m.div>
  );
};
